<template>
    <div class="content-positining text input-forms-size" style="top: 16%;">
        <div class="headlin-text"> Congratulations</div>
        <div style="padding-top: 3%; padding-bottom: 3%; margin-top: 3.5em;">You have successfully created an account with Adway.</div>
        <div style="padding-top: 3%;">
          <button @click="homeButtonClick" class="adway-btn-2-class" style="margin-bottom:4%">
            <span class="btn__text__normal">Home</span>
          </button>
          <button class="adway-btn-class" @click="handleLoginResponse">
            <span class="btn__text__bold">
              Go to my Account
            </span>
          </button>
        </div>
    </div>
</template>

<script>
import HTTPRequest from './../../../../plugins/utils/HttpRequest.js'
// import Config from './../../../../plugins/utils/Config.js'
import store from '@store/index.js'
import toast from '@utils/toast.js'
export default {
  name: 'ConfitmationView',
  data: function () {
    return {
      // config: Config,
      store: store
    }
  },
  props: {
    response: Object,
    user: String
  },
  methods: {
    homeButtonClick () {
      this.$router.push('/')
    },
    handleLoginResponse () {
      if (this.response.result === 'failure') {
      } else {
        store.commit('setToken', this.response)
        this.getProfile()
      }
    },
    getProfile () {
      var request = new HTTPRequest()
      var url = '/get/profile'
      var body = {
        user: this.user,
        code: store.state.token.token,
        API_KEY: ''
      }
      request.makeRequest('POST', url, body).then((response) => {
        var jsonparse = JSON.parse(response)
        if (jsonparse.code === 0) {
          this.store.commit('setUser', jsonparse.data[0])
          this.$router.push('/advertiser/dashboard')
        } else {
          toast.errorMessage(jsonparse.message)
        }
      }).catch((error) => {
      })
    }
  },
  created: function () {
    toast.successMessage('User created')
  }
}
</script>
